export default __webpack_public_path__ + "static/media/Refined Philtre of Strength.b8d5ddf4.jpg";